import classNames from "classnames";

import type { DirectionalIconComponent } from "@jti/brand-icons";

import styles from "./LabeledIcon.module.scss";

type LabeledIconProps = {
  label: string;
  Icon: DirectionalIconComponent;
  iconClassName?: string;
  dataTestId?: string;
};

export const LabeledIcon = ({ label, Icon, iconClassName, dataTestId }: LabeledIconProps) => {
  return (
    <div className={styles.container} {...(dataTestId && { "data-testid": dataTestId })}>
      <Icon className={classNames(styles.icon, iconClassName)} aria-hidden="true" />
      <div className={styles.text}>{label}</div>
    </div>
  );
};
